import {
  useFeatureGate,
  useGetExperimentValue,
} from '@trello/feature-gate-client';

import { useIsInboxBoard } from './useMemberInboxIds';

/**
 * Determines whether or not labels are available for the current context.
 * This hook is expected to be called within a board context (not necessarily on an individual card).
 * @returns True if labels are available on this board; false otherwise.
 */
export const useAreLabelsAvailable = (): boolean => {
  const { value: inboxLabelsEnabled } = useFeatureGate('phx_inbox_labels');
  const isInbox = useIsInboxBoard();
  const { cohort, loading } = useGetExperimentValue({
    experimentName: 'trello_inbox_labels',
    parameter: 'cohort',
    fireExposureEvent: isInbox,
  });

  // Always show labels on boards, regardless of gates or experiments
  if (!isInbox) {
    return true;
  }

  // The feature gate overrides the normal behavior of hiding the label UI on inbox cards
  // While we switch to an experiment from a normal gate, continue to support the old gate
  if (inboxLabelsEnabled) {
    return true;
  }

  return !loading && cohort === 'treatment';
};
